<template>
  <div
    class="portfolio-pages-wrapper section-space--ptb_100 border-bottom gray-gradient"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div
            class="section-title-wrapper text-center section-space--mb_60 wow move-up"
          >
            <h2 class="section-title font-weight--bold mb-15">Our Services</h2>
            <p>
              We pride ourselves in being a multi-talented and broad team that
              can span across various<br />
              ICT services some of whicare listed hereunder.
            </p>
          </div>

          <hr class="my-4" />
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div
            class="col-sm-4"
            style="margin-bottom: 20px"
            v-for="(service, key) in services"
            :key="key"
          >
            <div class="text-center mb-4 d-flex flex-column h-100 card">
              <router-link to="#" class="single-grid-caption">
                <div class="single-portfolio__thumbnail">
                  <img
                    class="img-fluid"
                    :src="service.image"
                    :alt="service.name"
                  />
                </div>
              </router-link>
              <br />
              <div class="post-info">
                <p>{{ service.name }}</p>
                <h5 class="post-title font-weight--bold">
                  <router-link to="#">{{ service.name }}</router-link>
                </h5>
              </div>
              <div class="load-more-button text-center mt-auto">
                <p class="price">{{ service.price }}</p>
                <router-link
                  :to="{
                    name: 'purchase-service',
                    query: {
                      subject: service.name,
                      refno: randomReferenceCode,
                      price: service.price,
                      serviceName: service.name,
                    },
                  }"
                >
                  <button class="ht-btn ht-btn-md ht-btn--outline loadMore">
                    <i class="fa-solid fa-cart-shopping"></i>Add to basket
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import services from "../data/ourservices";

export default {
  components: {},

  data() {
    return {
      services,
      randomReferenceCode: "",
    };
  },
  mounted() {
    // Generate a unique random code based on current time
    this.generateRandomCode();
  },
  methods: {
    generateRandomCode() {
      const timestamp = new Date().getTime().toString();
      const randomPart = Math.random().toString(36).substr(2, 5).toUpperCase();
      this.randomReferenceCode = timestamp + randomPart;
    },
  },
};
</script>

<style>
.card {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  margin: auto;
  text-align: center;
  font-family: arial;
  padding: 15px;
}

.price {
  color: grey;
  font-size: 22px;
}

.card button {
  border: none;
  outline: 0;
  color: white;
  background-color: #2e3280;
  text-align: center;
  cursor: pointer;
  width: 100%;
  font-size: 18px;
}

.card button:hover {
  opacity: 0.7;
}
</style>
